"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Backbone = window.Backbone;
var featureManager = window.featureManager;



var path = require('path');

var TitleAuthorTemplate = "<a title=\"<%= text %>\" class=\"secondary-hover-underline\" href=\"<%= href %>\" aria-label=\"<%= label %>\"><%= text %></a>";
var TitleAuthor = Backbone.View.extend({
  template: _.template(TitleAuthorTemplate),
  className: 'title-author',
  tagName: 'p',
  initialize: function initialize() {
    if (this.model.get('type').id !== 'periodicals') {
      this.render();
    }
  },
  render: function render() {
    var title = this.model.toJSON();
    var contents = window.html('cover.noAuthorAvailable');

    if (!_.isEmpty(title.firstCreatorName)) {
      var creatorName = featureManager.isEnabled('fixHtmlTagsInCopy') ? title.firstCreatorName : _.escape(title.firstCreatorName);
      var viewData = {
        href: window.url(window.routes.searchByType, {
          type: 'creatorId',
          query: title.firstCreatorId,
          sortBy: 'newlyadded'
        }),
        label: window.text('cover.searchByAuthor', {
          author: creatorName
        }),
        text: creatorName
      };
      contents = window.text('byLine', {
        creator: this.template(viewData)
      });
    }

    this.$el.html(contents);
  }
});
var _default = TitleAuthor;
exports["default"] = _default;